define('viewmodels/pages/cash/methods/AmountOnlyViewModel',['knockout'], function(ko) {

    function AmountOnlyViewModel(AmountStep, navigation, paymentModel, Wizard) {

        this.wizardModel = new Wizard({
            steps: [
                new AmountStep(paymentModel)
            ]
        });
    }

    AmountOnlyViewModel.prototype.getView = function() {
        return 'views/pages/cash/methods/wizardMethod.html';
    };

    return AmountOnlyViewModel;
});

